import { Component, OnInit } from '@angular/core';
import { DisplayGrid, GridsterConfig, GridsterItem, GridType } from 'angular-gridster2';
import { AssetService } from '../asset';

@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss']
})
export class DashboardPageComponent implements OnInit {

  options: GridsterConfig;
  dashboard: Array<GridsterItem>;

  assetsItem: GridsterItem = {
    cols: 1,
    rows: 1,
    y: 0,
    x: 0,
    title: 'Assets',
    value: 0,
    loading: true,
    dragEnabled: true,
    resizeEnabled: true
  };

  ammountItem: GridsterItem = {
    cols: 1,
    rows: 1,
    y: 0,
    x: 0,
    title: 'Ammount',
    value: {
      ammount: 0.0,
      deprecationAmmount: 0.0
    },
    loading: true,
    dragEnabled: true,
    resizeEnabled: true
  };

  ammountByClassesItem: GridsterItem = {
    cols: 3,
    rows: 3,
    y: 0,
    x: 0,
    title: 'Ammount by Classes',
    loading: true,
    dragEnabled: true,
    resizeEnabled: true,

    barChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            }
        }]
    }
    },
    barChartLabels: [],
    barChartType: 'bar',
    barChartLegend: false,
    barChartPlugins: [],
    barChartData: [
      { data: [],
        label: 'Ammount',
        backgroundColor: '#3f51b5',
        borderColor: '#3f51b5',
        borderWidth: 0,
        hoverBackgroundColor: '#536dfe',
        hoverBorderColor: '#536dfe',
        hoverBorderWidth: 0
      }
    ]
  };



  static itemChange(item, itemComponent) {
    // console.info('itemChanged', item, itemComponent);
  }

  static itemResize(item, itemComponent) {
    // console.info('itemResized', item, itemComponent);
  }

  constructor(public assetService: AssetService) { }

  ngOnInit(): void {
    this.options = {
      itemChangeCallback: DashboardPageComponent.itemChange,
      itemResizeCallback: DashboardPageComponent.itemResize,
      gridType: GridType.Fit,
      displayGrid: DisplayGrid.None,
      draggable: {
        ignoreContent: true,
        dragHandleClass: 'drag-handler'
      },
      resizable: {
        enabled: true
      }
    };

    this.dashboard = [
      { cols: 2, rows: 2, y: 0, x: 0, title: 'Ammount by Places', dragEnabled: true, resizeEnabled: true },
      { cols: 2, rows: 2, y: 0, x: 0, title: 'Age', dragEnabled: true, resizeEnabled: true },
      { cols: 2, rows: 2, y: 0, x: 0, title: 'Assets by Classes', dragEnabled: true, resizeEnabled: true }
    ];

    this.assetService.count().subscribe(
      (data) => {
        this.assetsItem.value = data;
        this.assetsItem.loading = false;
      }
    );

    this.assetService.ammount().subscribe(
      (data) => {
        this.ammountItem.value = data;
        this.ammountItem.loading = false;
      }
    );

    this.assetService.ammountByClasses().subscribe(
      (data) => {
        for (const c of data) {
          this.ammountByClassesItem.barChartLabels.push(c.title);
          this.ammountByClassesItem.barChartData[0].data.push(c.ammount);
        }
        this.ammountByClassesItem.loading = false;
      }
    );

  }

  changedOptions() {
    this.options.api.optionsChanged();
  }

  removeItem(item) {
    this.dashboard.splice(this.dashboard.indexOf(item), 1);
  }

  addItem() {
    this.dashboard.push({} as any);
  }



}
